"use client"
import {
  useInputGroup
} from "./chunk-N7GDIMME.mjs";

// src/input-element.tsx
import { forwardRef, ui } from "@yamada-ui/core";
import { cx } from "@yamada-ui/utils";
import { jsx } from "react/jsx-runtime";
var InputElement = forwardRef(
  ({
    className,
    isClick = false,
    isClickable = isClick,
    clickable = isClickable,
    placement = "left",
    ...rest
  }, ref) => {
    const { fieldFontSize, fieldHeight, styles } = useInputGroup();
    const css = {
      alignItems: "center",
      cursor: clickable ? "pointer" : "auto",
      display: "flex",
      fontSize: fieldFontSize,
      h: "100%",
      justifyContent: "center",
      [placement === "left" ? "insetStart" : "insetEnd"]: "0",
      pointerEvents: clickable ? "auto" : "none",
      position: "absolute",
      top: "0",
      w: fieldHeight,
      zIndex: "fallback(kurillin, 9)",
      ...styles.element
    };
    return /* @__PURE__ */ jsx(
      ui.div,
      {
        ref,
        className: cx("ui-input__element", className),
        __css: css,
        ...rest
      }
    );
  }
);
InputElement.displayName = "InputElement";
InputElement.__ui__ = "InputElement";
var InputLeftElement = forwardRef(
  ({ className, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(
      InputElement,
      {
        ref,
        className: cx("ui-input__element--left", className),
        placement: "left",
        ...rest
      }
    );
  }
);
InputLeftElement.displayName = "InputLeftElement";
InputLeftElement.__ui__ = "InputLeftElement";
var InputRightElement = forwardRef(
  ({ className, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(
      InputElement,
      {
        ref,
        className: cx("ui-input__element--right", className),
        placement: "right",
        ...rest
      }
    );
  }
);
InputRightElement.displayName = "InputRightElement";
InputRightElement.__ui__ = "InputRightElement";

export {
  InputLeftElement,
  InputRightElement
};
//# sourceMappingURL=chunk-3TI2NWMJ.mjs.map